import ServiceTags from "../filter_mobile/service_tags.js.jsx";
import FilterCondition from "./filter_condition.js";

export default class PopularServiceTags extends ServiceTags {
  constructor (props) {
    super(props);
    this.serviceBlock = this.serviceBlock.bind(this);
    this.serviceBlocks = this.serviceBlocks.bind(this);
    this.onShowAllServiceTags = this.onShowAllServiceTags.bind(this);
    this.state = {
      show_all_service_tags: false,
      maxBlocks: 6
    }
  }

  onShowAllServiceTags () {
    this.setState({ show_all_service_tags: true }, () => {
      let $filterPopup = $('#filter-popup');
      $filterPopup.animate({scrollTop: $filterPopup.scrollTop() + $(window).height() - 100}, 400);
    });

    window.ymReachGoal('filter:sidebar:services-show-more-btn');
  }

  popularServiceBlocks () {
    return this.tagsToRender().map((service_tag, i) => {
      if ((!this.props.show_chosen || this._isChecked(service_tag.id)) && i < this.state.maxBlocks) {
        return this.serviceBlock(service_tag, i)
      } else return null
    });
  }

  serviceBlocks() {
    return this.tagsToRender().map((service_tag, i) => {
      if ((!this.props.show_chosen || this._isChecked(service_tag.id)) && i >= this.state.maxBlocks) {
        return super.serviceBlock(service_tag, i)
      } else return null
    });
  }

  serviceBlock (service_tag, i) {
    return (
      <label className={`popular-services__tag ${this._isChecked(service_tag.id) ? 'popular-services__tag-checked' : ''}`}
             key={i}
      >
        <input className='hidden'
               type="checkbox"
               onChange={this.handleChange}
               value={service_tag.id}
               data-id={service_tag.id}
               checked={this._isChecked(service_tag.id)}
        />
        <div className='div-service-icon div-service-icon_full-width'
             style={{backgroundImage: `url(${service_tag.icon})`}}
        />
        {service_tag.name}
        {this.props.counts && !this._isChecked(service_tag.id) &&
          <div className={"mdc-checkbox__label-count"}>
            {this.props.counts[service_tag.id] ?? 0}
          </div>
        }
      </label>
    )
  }

  moreButton () {
    return (
        <a role="button"
           className='popular-services__show-more m-t-16'
           onClick={this.onShowAllServiceTags}
        >
          Показать еще
        </a>
    );
  }

  render () {
    if (this.props.show_chosen && (this.props.value || []).length === 0) {
      return null;
    }

    const filteredTagsProperties = this.props.filtered_tags_properties

    const tagsProperties = filteredTagsProperties &&
        <FilterCondition condition_name={''}
                         condition_param={this.props.tags_param}
                         filter={this.props.filter}
                         enabled_ids={this.props.tags_enabled_ids}
                         condition_items={this.props.tags_condition_items}
                         filtered_all_categories={"true"}
        />
    return (
      <div className="filter-row filter-row_no-border">
        <div className="filter-row__title">
          {this.props.service_name}
        </div>
        <div className='popular-services m-b-16'>
          {this.popularServiceBlocks()}
        </div>
        {!this.serviceBlocks().some(checked => checked) || this.popularServiceBlocks().length <= this.state.maxBlocks || this.state.show_all_service_tags ? '' : this.moreButton()}
        {this.serviceBlocks().some(checked => checked) && this.state.show_all_service_tags ?
          <div className="filter-row__title_small m-b-8 m-t-8">
            другие услуги:
          </div> : '' }
        {this.state.show_all_service_tags ? tagsProperties : ''}
        {this.state.show_all_service_tags ? this.serviceBlocks() : ''}
      </div>
    );
  }

}
